module.exports = __webpack_public_path__ + "media/images/ibjjf/card-4dc525a5569f65f999f30f5c59b9b326.jpg";